@if (isExpanded()) {
    <div id="fab-dismiss" (click)="onToggleFab()"></div>
}

<div class="fab-container">
    @for (button of buttons(); track button.caption; let i = $index) {
        @if (i === 0 || (i === 1 && buttons().length === 2)) {
            @if (isTranslationKey(button.caption)) {
                <button
                    mat-fab
                    matTooltip="{{ button.caption | translate }}"
                    matTooltipPosition="left"
                    matTooltipShowDelay="1000"
                    (click)="onButtonClick(button, $event)"
                    [disabled]="button.isDisabled"
                    [color]="button.color"
                    [attr.color]="button.color">
                    <mat-icon [ngClass]="button.iconClasses()" [style.color]="button.iconColor">{{ button.icon }}</mat-icon>
                </button>
            } @else {
                <button
                    mat-fab
                    matTooltip="{{ button.caption }}"
                    matTooltipPosition="left"
                    matTooltipShowDelay="1000"
                    (click)="onButtonClick(button, $event)"
                    [disabled]="button.isDisabled"
                    [color]="button.color"
                    [attr.color]="button.color">
                    <mat-icon [ngClass]="button.iconClasses()" [style.color]="button.iconColor">{{ button.icon }}</mat-icon>
                </button>
            }
        }

        @if (i === 1 && buttons().length > 2) {
            <button mat-fab class="fab-toggler" (click)="onToggleFab()" color="white">
                <mat-icon [ngClass]="button.iconClasses()" [@fabToggler]="isExpanded() ? 'active' : 'inactive'">
                    {{ isExpanded() ? 'close' : 'more_vert' }}
                </mat-icon>
            </button>
        }
    }

    @if (buttons().length > 2 && isExpanded()) {
        <div [@speedDialStagger]>
            @for (button of buttons() | slice: 1; track button.caption) {
                @if (isTranslationKey(button.caption)) {
                    <button
                        mat-mini-fab
                        [color]="button.color"
                        [attr.color]="button.color"
                        matTooltip="{{ button.caption | translate }}"
                        matTooltipPosition="left"
                        matTooltipShowDelay="1000"
                        (click)="onButtonClick(button, $event)"
                        [disabled]="button.isDisabled">
                        <mat-icon [ngClass]="button.iconClasses()" [style.color]="button.iconColor">{{ button.icon }}</mat-icon>
                    </button>
                } @else {
                    <button
                        mat-mini-fab
                        [color]="button.color"
                        [attr.color]="button.color"
                        matTooltip="{{ button.caption }}"
                        matTooltipPosition="left"
                        matTooltipShowDelay="1000"
                        (click)="onButtonClick(button, $event)"
                        [disabled]="button.isDisabled">
                        <mat-icon [ngClass]="button.iconClasses()" [style.color]="button.iconColor">{{ button.icon }}</mat-icon>
                    </button>
                }
            }
        </div>
    }
</div>
